module.exports = __webpack_public_path__ + "static/media/loujniki.3fd202ca.jpg";